import RemoveCircle from 'assets/icons/RemoveCircle'
import { NavBar } from 'components/NavBar/NavBar'
import { NoData } from 'components/NoData'
import { Pagination } from 'components/Pagination/Pagination'
import { clearCapabilities, deleteCapability, getCapabilities } from 'features/capabilities/capabilitiesSlice'
import { setConfirmModal } from 'features/global/globalSlice'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { Button, Flex, GridItem, GridWrapper, ItemsGrid, MainHeadline, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { ICapability } from 'types/api/capabilitiesApi.interface'
import { ModalTypes } from 'types/global.interface'
import { getParams, handlePagination } from 'utils/helpers'
import { CapabilitiesModal } from './CapabilitiesModal'

export const Capabilities = () => {
    const { data, totalPages } = useSelector((state: RootState) => state.capabilities)
    const dispatch = useDispatch<AppDispatch>()
    const [params, setParams] = useState<any>(getParams({ location, ap: { sd: 'a', s: 'name' } }))
    const [modal, setModal] = useState<{ open: boolean, value: ICapability }>({ open: false, value: null })

    useQueryPagination({ fetchFunctions: [getCapabilities], cleanUpFunctions: [clearCapabilities], params })

    const handleRemove = (e, id: number) => {
        e.stopPropagation();
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deleteCapability(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                },
                word: 'delete capability',
            }),
        )
    }

    return <>
        <NavBar
            input
            defaultValue={params.q}
            placeholder='Search Capabilitites...'
            setParams={setParams}
            searchFields={['name']}
        />
        <PageWrapper>
            <Flex between center mb='16' >
                <MainHeadline>Capabilities</MainHeadline>
                <Button orange onClick={() => setModal({ open: true, value: null })}>
                    Add Group
                </Button>
            </Flex>
            <GridWrapper>
                {data?.length ? <ItemsGrid columns={3}>
                    {data?.map((item, key: number) => {
                        return (
                            <GridItem key={key} onClick={() => setModal({ open: true, value: item })} >
                                <p >{item.name}</p>
                                <Flex center justcenter onClick={(e) => handleRemove(e, item.id)}>
                                    <RemoveCircle />
                                </Flex>
                            </GridItem>
                        )
                    })}
                </ItemsGrid> : <NoData />}
            </GridWrapper>
        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams)}
                pageCount={Math.ceil(totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
        {modal.open && <CapabilitiesModal value={modal.value} closeModal={() => setModal({ open: false, value: null })} />}
    </>
}